module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Ferrarella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("This USA TODAY bestselling and RITA ® Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J6gcg7/tc-custom/9781488004926.jpg?1738388893225",
      "alt": "This image is the cover for the book Cavanaugh or Death, Cavanaugh Justice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cavanaugh or Death, Cavanaugh Justice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this romantic suspense mystery by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author, a run of grave robberies force two detectives to bury their burgeoning chemistry.")]), _c('br'), _c('br'), _vm._v("After losing two partners in the line of duty, major crimes detective Davis Gilroy isn’t about to get close to his new one. Especially when that partner is an optimistic blonde beauty with killer curves. Davis will do his job, keep a close eye on detective Moira Cavanaugh and not let her get under his skin. But when someone starts disturbing old graves in local cemeteries, he and Moira work long nights to solve the macabre mystery. Suddenly Davis finds himself caring too much about the strong, sexy woman who always has his back . . . and is gaining on his heart.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0